import { ItemType } from 'antd/lib/menu/hooks/useItems'
import { TFunction } from 'i18next'
import { Dispatch, SetStateAction, createContext } from 'react'
import { IRoute } from 'routes/IRoute'

export const generateItemsMenuTop = (
  t: TFunction,
  menus: Array<IRoute>
): Array<ItemType> => {
  return menus.map((item) => {
    const { path, icon, name, rootPath } = item
    return {
      key: rootPath + path,
      icon: <img className={name} src={icon} alt="" />,
      label: t(name || '')
    } as ItemType
  })
}

export type MenuSidebarProps = {
  collapse: boolean
  setCollapse: Dispatch<SetStateAction<boolean>>
  openKeys: string[] | undefined
  setOpenKeys: Dispatch<SetStateAction<string[] | undefined>>
}

export const MenuSidebarContext = createContext<MenuSidebarProps>({
  collapse: true,
  setCollapse: (_value) => {
    /** empty-func */
  },
  openKeys: [],
  setOpenKeys: (_value) => {
    /** empty-func */
  }
})
